import { PLANNED_READY_TIME as PLANNED_READY_TIME_FIELD } from "./";
import { ALL } from "../strings";
import { routeHasTerritory } from "../../utils/routes";

const DEFAULT_VALUE = {
  value: "0",
  label: ALL,
  functionParameters: { value: "0", label: ALL },
};

export const PLANNED_READY_TIME = {
  title: "Forecast Ready Time",
  field: PLANNED_READY_TIME_FIELD,
  mapToValues: (waves) =>
    (waves || []).reduce(
      (acc, { waveTime }) => {
        const value = {
          value: `${acc.length}`,
          label: waveTime || "Final",
        };
        acc.push({
          ...value,
          functionParameters: value,
        });
        return acc;
      },
      [DEFAULT_VALUE]
    ),
  filterCallback: ({ route, label }) =>
    label === ALL ||
    (routeHasTerritory(route) &&
      (route.plannedReadyTimeAsString || "Final") === label),
  volumeOverlayRequired: false,
};
